module.exports = __webpack_public_path__ + "static/media/p17.fccf16d7.jpeg";